var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-2-5h24v24H-2z","key":0}),React.createElement("path",{"fill":"#B8BDC1","d":"M19.997 1.973L20 2v9c0 1.102-.897 2-2 2H2c-1.103 0-2-.898-2-2V2c0-.008.003-.017.003-.026l9.47 5.877a1 1 0 0 0 1.054-.001zM18 .001c.352 0 .677.1.965.26L10 5.824 1.035.261c.287-.16.613-.26.965-.26z","key":1})]));
}

Email.defaultProps = {"width":"20","height":"13","viewBox":"0 0 20 13"};

module.exports = Email;

Email.default = Email;
